import React, { FC } from 'react';
import { useBestPostsForAllMetricsQuery } from 'app/modules/insights/modules/postsPerformance/hooks/useBestPostsForAllMetricsQuery';
import { Page } from 'app/modules/insights/types/Page';
import { MetricProperty } from 'app/modules/insights/types/MetricProperty';
import InsightsConfig from 'app/config/insights';
import { Alert } from '@kontentino/ui';
import { Dayjs } from 'dayjs';
import { Trans } from 'react-i18next';

type Props = {
  page: Page;
  startDate: Dayjs;
  endDate: Dayjs;
  metric: MetricProperty;
  types: number[];
};

const BestPostsHasFewerCountAlert: FC<Props> = (props) => {
  const { posts } = useBestPostsForAllMetricsQuery(props);

  if (
    posts &&
    posts.length > 0 &&
    posts.length < InsightsConfig.MAX_POSTS_PER_METRIC
  ) {
    return (
      <Alert>
        <Trans
          i18nKey="insights.postsPerformance.bestPostsHasFewerCountAlert.message"
          values={{ count: InsightsConfig.MAX_POSTS_PER_METRIC }}
          components={{ b: <b /> }}
        />
      </Alert>
    );
  }

  return null;
};

export default BestPostsHasFewerCountAlert;
